<template>
  <div class="common-table">
    <!-- :cell-style="{background:'#193053',color:'white'}"  -->
    <!-- :header-cell-style="{background:'#0A1F3C',color:'#1D83C9'}" -->
    <el-table :data="tableData"  style="width: 100%; height:550px" height="90%"  
    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    row-key="ZZJGBH"
    highlight-current-row
    @row-click="rowc"
    @current-change="handleCurrentChange">
      <!-- 选择框 -->
      <el-table-column label="序号" :type="selection" :width="lineWidth" align="center">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ (config.page - 1) * 20 + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- 数据列 -->
      <el-table-column show-overflow-tooltip v-for="item in tableLabel" :key="item.prop" :label="item.label" :width="item.width ? item.width : 145" align="center">
        <template slot-scope="scope">
          <span> {{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="150" align="center">
        <template slot-scope="scope">
           <span v-if="formLabel.detail" class="btn_eadd" @click="handleDetail(scope.row)">详情</span>
              <el-divider v-if="formLabel.edit || formLabel.add"  direction="vertical"></el-divider>
              <el-dropdown v-if="formLabel.edit || formLabel.add">
                  <span class="el-dropdown-link">
                      其他<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                      <!-- <el-dropdown-item>
                          <span v-if="formLabel.edit" class="btn_eadd" @click="handleDelete(scope.row)">删除</span>
                      </el-dropdown-item> -->
                      <el-dropdown-item>
                         <span v-if="formLabel.add" class="btn_eadd"  @click="handleEdit(scope.row)">编辑</span>
                      </el-dropdown-item>
                      <!-- <el-dropdown-item v-if="formLabel.disable">
                             <span v-if="formLabel.detail" class="btn_eadd" @click="closeDetail(scope.row)">禁用</span>
                             <span v-if="formLabel.detail" class="btn_eadd" @click="openDetail(scope.row)">启用</span>
                      </el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :hide-on-single-page="value" background class="pager" layout="prev, pager, next" :total="config.total" :current-page.sync="config.page" @current-change="changePage" :page-size="20">
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Array,
    tableLabel: Array,
    config: Object,
    selection:String,
    formLabel:Object,
    lineWidth: Number
  },
  data(){
    return{
      value: false
    }
  },
  methods: {
    noop(row) {
    },
    rowc(row) {
      this.$emit('gl', row)
    },
    handleEdit(row) {
      this.$emit('edit', row)
    },
    handleDetail(row){
      this.$emit('detail', row)
    },
    handleDelete(row) {
      this.$emit('del', row)
    },
     closeDetail(row) {
      this.$emit('close', row)
    },
    openDetail(row) {
      this.$emit('open', row)
    },
    changePage(page) {
      this.$emit('changePage', page)
    },
    handleCurrentChange(val) {
       this.$emit('currentChange', val)
      }
  }
}
</script>

<style lang="scss" scoped>
.common-table {
  // height: calc(100% - 62px);
  height: 100%;
  position: relative;
  
  .pager {
    position: absolute;
    width: 400px;
    text-align: center;
    bottom: 2%;
    right: calc(50% - 200px);
  }
}
.btn_eadd{
  padding-left: 10px;
}
</style>
